import React, { useState, useEffect } from 'react';
import { TextField, Button, Container, Typography, Box, Card, CardContent, CardActions, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Switch, Grid } from '@mui/material';
import { Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { getAllHomepages, createHomepage, updateHomepage, deleteHomepage, updateHomepageActiveStatus } from '../services/api';

const HomeSettings = () => {
  const [homepages, setHomepages] = useState([]);
  const [currentHomepage, setCurrentHomepage] = useState({ title: '', html: '', is_active: false });
  const [isEditing, setIsEditing] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  useEffect(() => {
    fetchHomepages().then(() => {
      console.log('Fetched homepages successfully.');
    });
  }, []);

  const fetchHomepages = async () => {
    try {
      const response = await getAllHomepages();
      setHomepages(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error('Failed to fetch homepages:', error);
      setHomepages([]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isEditing) {
        await updateHomepage(currentHomepage.id, currentHomepage);
      } else {
        await createHomepage(currentHomepage);
      }
      fetchHomepages();
      setCurrentHomepage({ title: '', html: '', is_active: false });
      setIsEditing(false);
      setOpenDialog(false);
    } catch (error) {
      console.error('Failed to save homepage:', error);
    }
  };

  const handleEdit = (homepage) => {
    setCurrentHomepage(homepage);
    setIsEditing(true);
    setOpenDialog(true);
  };

  const handleDelete = async (id) => {
    try {
      await deleteHomepage(id);
      fetchHomepages();
    } catch (error) {
      console.error('Failed to delete homepage:', error);
    }
  };

  const handleActiveChange = async (id, newActiveStatus) => {
    try {
      await updateHomepageActiveStatus(id, newActiveStatus);
      fetchHomepages();
    } catch (error) {
      console.error('Failed to update homepage active status:', error);
    }
  };

  return (
    <Container maxWidth="md">
      <Typography variant="h5" component="h1" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
        主页设置
      </Typography>
      <Button variant="contained" color="primary" onClick={() => {
        setCurrentHomepage({ title: '', html: '', is_active: false });
        setIsEditing(false);
        setOpenDialog(true);
      }} sx={{ mb: 2 }}>
        添加新主页
      </Button>
      <Grid container spacing={2}>
        {homepages.map((homepage) => (
          <Grid item xs={12} key={homepage.id}>
            <Card>
              <CardContent>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="h6">{homepage.title}</Typography>
                  <Switch
                    checked={homepage.is_active}
                    onChange={(e) => handleActiveChange(homepage.id, e.target.checked)}
                    inputProps={{ 'aria-label': 'Is Active' }}
                  />
                </Box>
              </CardContent>
              <CardActions>
                <IconButton aria-label="edit" onClick={() => handleEdit(homepage)}>
                  <EditIcon />
                </IconButton>
                <IconButton aria-label="delete" onClick={() => handleDelete(homepage.id)}>
                  <DeleteIcon />
                </IconButton>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>{isEditing ? '编辑主页' : '添加新主页'}</DialogTitle>
        <DialogContent>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="title"
              label="标题"
              name="title"
              value={currentHomepage.title}
              onChange={(e) => setCurrentHomepage({ ...currentHomepage, title: e.target.value })}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              id="html"
              label="HTML 内容"
              name="html"
              multiline
              rows={10}
              value={currentHomepage.html}
              onChange={(e) => setCurrentHomepage({ ...currentHomepage, html: e.target.value })}
            />
            <Box sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
              <Typography>是否生效</Typography>
              <Switch
                checked={currentHomepage.is_active}
                onChange={(e) => setCurrentHomepage({ ...currentHomepage, is_active: e.target.checked })}
                inputProps={{ 'aria-label': 'Is Active' }}
              />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>取消</Button>
          <Button onClick={handleSubmit}>{isEditing ? '更新' : '创建'}</Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default HomeSettings;
